import { mode } from "crypto-js";
import { schema } from "./schema";
import { SendSharp } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import reqEmpresa from "../../../services/reqMultiTenant/reqEmpresa";
import Notification, { handleMessageError, handleMessageInfo, handleMessageWarning } from "../../../components/toast";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import crypt from "../../../util/crypt";
import reqColaborador from "../../../services/reqMultiTenant/reqColaborador";
import { HandleAddLocationStorage } from "../../../util/libLocalStorage";
import reqProduto from "../../../services/reqMultiTenant/reqProduto";
import { set } from "date-fns";
import { ContextGlobal } from "../../../context";

export const IndexHook = () => {
	//implemente o hook navigate
	const navigate = useNavigate();
	const { id } = useParams();

	const [productSelected, setProductSelected] = useState("");
	const { setListPermissionsData, setModulopermitted, lastPermissionsFetchRef } = useContext(ContextGlobal);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchProduct = async () => {
			try {
				const response = await reqProduto.listProductsSZId(id);

				setProductSelected(response.data[0].nome);

				return response;
			} catch (error) {
				handleMessageError(error);
				// navigate("/home");
			}
		};
		fetchProduct();
	}, [id, navigate]);

	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		resolver: zodResolver(schema),
		defaultValues: {
			contato: "",
			nome: "",
			telefone_1: "",
			email: "",
			Senha: "",
			id_produto: id,
		},
	});

	const errosAfterPost = (field, message) => {
		setError(field?.toLowerCase(), { type: "manual", message: message });
	};

	const handleOnSubmit = async (data) => {
		try {
			const newData = { ...data, id_cidade: 3516200 };
			const insertResponse = await reqEmpresa.insert(newData);

			handleMessageInfo("Registro salvo com sucesso.");

			reset();
			processaLogin(data.email, data.senha);
			// navigate("/download");
		} catch (error) {
			if (error.field) errosAfterPost(error.field, error.message);
			handleMessageWarning(error.message);
		}
	};

	async function processaLogin(email, senha) {
		try {
			setLoading(true);
			const body = { email, senha };

			const response = await reqColaborador.login(body);

			const collaboratorData = response.data.colaborador[0];

			await HandleAddLocationStorage(collaboratorData);

			const responseApps = response.data.colaborador.map((item) => ({
				modulo: item.modulo,
				status: item.status_modulo,
				dataExpiracao: item.data_expiracao,
				dias_restantes: item.dias_restantes,
			}));

			setModulopermitted(responseApps);

			// // await HandleAddAppsLocationStorage(responseApps);
			setListPermissionsData(collaboratorData);
			lastPermissionsFetchRef.current = Date.now();
			handleOpenAdmin();
		} catch (error) {
			handleMessageWarning(error.message);
		} finally {
			setLoading(false);
		}
	}

	const handleOpenAdmin = () => {
		// window.location.assign("/admin");
		window.location.assign("/");

		// navigate("/admin");
	};

	return {
		//hooks
		handleOnSubmit,

		loading,

		//useForm
		register,
		handleSubmit,
		control,

		productSelected,

		//formState
		reset,
		errors,
		isSubmitting,
	};
};
